import { Slide } from '@/components/core/Slide';
import videoFile from './eva-animated-loop-interim.webm';

export const slide = () => {
  return (
    <Slide
      notes="EVA animated appearance"
      autoNext={19000}
      visualizer="full"
      transition="fade"
      background={{
        video: videoFile,
      }}
    >
      <div className="!fixed !inset-0 !m-0 !p-0 !w-screen !h-screen !max-w-none !max-h-none"></div>
    </Slide>
  );
};
